import { gql } from '@apollo/client';


// Query for paginated Shipments for a consignment (matches schema: shipmentQuery.list)
export const GET_CONSIGNMENT_SHIPMENTS = gql`
  query GetConsignmentShipments($consignmentId: ID!, $limit: Int = 25, $offset: Int = 0) {
    shipment {
      list(consignmentId: $consignmentId, limit: $limit, offset: $offset) {
        items {
          shipmentNbr
          shipmentProductCount
        }
        pageInfo {
          totalCount
          status
          message
        }
      }
    }
  }
`;

// Query for paginated ShipmentProducts for a shipment (matches schema: shipmentQuery.listProducts)
export const GET_SHIPMENT_PRODUCTS = gql`
  query GetShipmentProducts($consignmentId: ID!, $shipmentNbr: String!, $limit: Int = 25, $offset: Int = 0) {
    shipment {
      listProducts(consignmentId: $consignmentId, shipmentNbr: $shipmentNbr, limit: $limit, offset: $offset) {
        items {
          productCode
          size
          division
          quantity
          netWeightInGrams
          manufacturerCountry
          components {
            classification {
              code
              descriptions {
                languageCode
                longDescription
                shortDescription
              }
            }
            additionalClassifications {
              code
              type
            }
            primaryFlag
            percentage
            price
            currency
            quantity {
              quantity
              reportingUnitOfMeasure
            }
            netWeight
            netNetWeight
            grossWeight
          }
          commercialDocuments {
            type
            documentNbr
            declarationAmount
            currency
            useAsBaseValue
            status
          }
          isSample
          stpDetails {
            stpCode
            authorityReportingCode
            effectiveFrom
            effectiveTo
            finalDecision
            finalDecisionDate
          }
          quality
          crpoNbr
          crPoItemVariantNbr
        }
        pageInfo {
          totalCount
          status
          message
        }
      }
    }
  }
`;
